import * as $ from "jquery";

function calculateWindowOffset(offset: number = 50) {
    let headerHeight = typeof $('#main-navbar').height() !== "undefined" ? $('#main-navbar').height() : 0;
    let infoBarHeight = typeof $('#info-bar').height() !== "undefined" ? $('#info-bar').height() : 0;
    let breadcrumbHeight = typeof $('#cart-breadcrumb-container').height() !== "undefined" ? $('#cart-breadcrumb-container').height() : 0;
    return headerHeight + infoBarHeight + breadcrumbHeight + offset;
}

export {calculateWindowOffset}import * as $ from "jquery";

function calculateWindowOffset(offset: number = 50) {
    let headerHeight = typeof $('#main-navbar').height() !== "undefined" ? $('#main-navbar').height() : 0;
    let infoBarHeight = typeof $('#info-bar').height() !== "undefined" ? $('#info-bar').height() : 0;
    let breadcrumbHeight = typeof $('#cart-breadcrumb-container').height() !== "undefined" ? $('#cart-breadcrumb-container').height() : 0;
    return headerHeight + infoBarHeight + breadcrumbHeight + offset;
}

export {calculateWindowOffset}